// extracted by mini-css-extract-plugin
export default {"fsSkuSelector":"sku-selector-module--fs-sku-selector--9b576"};